import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../../components/SEO';
import Hero from '../../components/Hero/Hero';
import Partners from '../../components/Partners/Partners';
import Services from '../../components/Services/Services';
import AIRPASection from '../../components/AIRPASection/AIRPASection';
import Clients from '../../components/Clients/Clients';
import Team from '../../components/Team/Team';
import CTA from '../../components/CTA/CTA';
import './Home.css';

const Home = () => {
  const { i18n } = useTranslation();
  const isFr = i18n.language === 'fr';

  return (
    <div className="home">
      <SEO
        title={isFr ? 'Automatisation Processus RPA, IA, Low-Code' : 'Process Automation — RPA, AI & Low-Code'}
        description={isFr
          ? 'OPTEAM Services : expert RPA, IA et Low-Code. Automatisez vos processus métiers, réduisez vos coûts et boostez votre productivité.'
          : 'OPTEAM Services: RPA, AI and Low-Code experts. Automate your business processes, cut costs and boost productivity.'
        }
        canonical="/"
      />
      <Hero />
      <Partners />
      <Services />
      <AIRPASection />
      <Clients />
      <Team />
      <CTA />
    </div>
  );
};

export default Home;